export default {
    title: "EBC金融集團 × 牛津大學經濟系 | EBC金融集團",
    description:
      "EBC金融集團與牛津大學共同推出『經濟學家的真實工作』（WERD）系列講座，集結頂尖學者，探討氣候經濟學的前瞻議題。一起了解我們如何透過金融知識教育培力投資人，共創透明且永續的經濟願景。",
    word1: "EBC金融集團 × 牛津大學經濟系",
    word2: "串連研究與實務，開創全球經濟新視野",
    word3: "精彩回顧",
    word4: "加入我們的合作旅程",
    word5: "合作概覽",
    word6: "WERD過往內容",
    word7: "特邀嘉賓",
    word8: "媒體報導",
    word9: "一切源於一個簡單的信念：教育，創造未來",
    word10:
      "在EBC金融集團，我們始終堅信，負責任的金融從全民可及的知識開始。因此，我們與牛津大學經濟系攜手合作，將世界一流的經濟研究帶入大眾視野。",
    word11:
      "透過《經濟學家的真實工作》（WERD）系列，我們致力於提升金融素養、激發關鍵對話，助力下一代投資者、領導者與思想者成長。",
    word12:
      "這次合作植基於EBC的核心價值：公平、負責與誠信，展現我們建立更透明且包容的金融未來的堅定承諾。",
    word13: "真實對話，創造影響",
    word14: "WERD第一期",
    word15: "「經濟學家都做了什麼」",
    word16: "活動詳情",
    word17:
      "探討稅收規避行為對全球及區域經濟的影響，強調金融素養在應對複雜經濟問題中的關鍵作用",
    word18: "演講嘉賓",
    word19: "Dr. Abi Adams，牛津大學經濟學教授，主持人",
    word20: "Dr. Sarah Clifford，牛津大學經濟系副教授",
    word21:
      "David Barrett，EBC Financial Group (UK) Ltd首席執行長，官方特邀嘉賓",
    word22: "活動時間",
    word23: "2024年3月1日",
    word24: "（「經濟學家的真實工作」2023-2024系列）",
    word25: "活動形式",
    word26: "Zoom線上直播回放",
    word27: "WERD第二期",
    word28: "維持可持續性發展：平衡經濟增長與氣候韌性",
    word29:
      "探討了宏觀經濟政策如何在確保經濟穩定的同時，幫助解決全球最迫切的環境挑戰",
    word30:
      "Banu Demir Pakel 博士，會議主持人，牛津大學對外交流合作副主任兼經濟學教授",
    word31: "Andrea Chiavari博士，講座主理人及圓桌討論嘉賓",
    word32:
      "Nicola Ranger博士，牛津大學環境變化研究全球金融組主任、牛津大學高級研究學者",
    word33: "David Barrett，EBC金融集團（英國）CEO",
    word34: "2024年11月\n（經濟學家都在做什麼？ 2024-2025期）",
    word35:
      "牛津大學經濟學系首次Hybrid event（線下與線上結合研討會），設有圓桌討論環節",
    word36: "特邀演講嘉賓",
    word37: "Nicola Ranger",
    word38: "牛津大學環境永續與馬丁系統研究中心主任",
    word39:
      "Nicola Ranger博士目前擔任牛津大學環境變遷研究所（ECI）轄下環境永續與馬丁系統研究計畫主持人。她創立了全球金融與經濟研究團隊，與國際貨幣基金組織（IMF）、世界銀行、永續金融網路（NGFS）和英國氣候金融風險論壇等機構合作，共同開發氣候金融壓力測試工具。她同時也是歐盟、新興市場永續投資專家小組、英國綠色科技分類顧問團、英國外交發展部及倫敦政經學院的顧問。",
    word40: "Andrea Chiavari",
    word41: "牛津大學經濟系副教授",
    word42:
      "Andrea Chiavari副教授專長於總體經濟學領域，研究企業發展動態與科技創新。他的研究目標是透過經濟模型促進永續發展，探討氣候變遷對企業生產力及資金配置的影響，同時致力於提升不確定環境下的經濟效率與調適能力。",
    word43: "Banu Demir Pakel",
    word44: "牛津大學經濟系副教授",
    word45:
      "Banu副教授專研國際貿易與發展經濟學的跨領域研究，探討企業如何因應貿易衝擊，以及這些因應策略如何影響總體經濟成長與所得分配。她是歐洲經濟政策研究中心（CEPR）國際貿易與區域經濟研究計畫成員，同時也是慕尼黑經濟研究所（CESifo）研究網絡成員。",
    word46: "David Barrett",
    word47: "EBC金融集團（英國）執行長",
    word48:
      "David Barrett是EBC 金融集團(英國) CEO ，在國際資產多元化配置、結構性風險防範領域有超過35年經驗，親歷多個市場週期，曾主導全球最大投資集團美國AIG的執行與管理工作，推動了華爾街產品架構和合規風控等領域的一系列變革，為後金融危機時代的風險規避和流動性管理建立了可行性框架。",
    word49: "Sarah Clifford",
    word50: "牛津大學經濟學副教授",
    word51:
      "Sarah Clifford博士作為牛津大學「避稅經濟學」領域的學術巨擘，致力於探索避稅經濟學背後的經濟學原理，以及稅收相關的經濟行為模型。 Sarah Clifford博士是最早利用跨國面板資料研究MNE ETR的學者之一，主導並提出了經合組織OECD有關稅基侵蝕的「GloBE」法案，極大地推動了BEPS包容性框架的建構。在其最新論文《避稅的全球影響及其對政策的啟示》中，她深入分析了避稅經濟學如何在全球範圍內對經濟產生影響，以及政府如何透過有效的政策干預來減少這一現象。",
    word52: "Abi Adams-Prassl",
    word53: "牛津大學經濟學教授",
    word54:
      "Abi Adams-Prassl教授主攻應用微觀經濟學，擅長透過實證方法將數據引入決策模型中，輔助微觀個體和家庭做出決策。作為英國政府科學辦公室的專家小組成員，Abi Adams-Prassl教授主導了英國政府的風險管理和彈性規劃，並將其從短期擴展為長期目標；同時，作為跨學術和政策研究領域的權威，Abi Adams -Prassl教授也制定了英國法律體系中有關司法的量化框架，確定了大數據環境中平衡訴諸司法和開放司法原則。",
    word55: "查看更多",
    word56: "最新消息",
    word57: "攜手共啟合作新篇章",
    word58: "EBC正積極尋求與全球理念相近的機構及創新推手展開更多合作。",
    word59: "聯絡我們",
    placeholder1: "貴姓/暱稱",
    placeholder2: "\n電子信箱",
    placeholder3: "手機號碼",
    placeholder4: "\n驗證碼",
  }